import { Button, DataSource, Label, LayoutHeader, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLoginLogoutHistList extends Layout {
    buttonExpand: Button;
    labelFilters: Label;
    layoutheaderMCLoginLogoutHist: LayoutHeader;
    panelFilter: Panel;
    panelFilterContent: Panel;
    panelFilterHeader: Panel;
    panelTable: Panel;
    searchDriverId: Textbox;
    searchLoginDate: Textbox;
    searchLoginPositionId: Textbox;
    searchLogoutDate: Textbox;
    searchLogoutPositionId: Textbox;
    searchTractorId: Textbox;
    searchpanelMcLoginLogoutHist: SearchPanel;
    sourceMcLoginLogoutHist: DataSource;
    tableMobileCommLoginLogoutHist: Table;
}
